import styled from "styled-components";

import { type ProgressBarKind } from "./index";

export const Progress = styled.progress`
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
`;

export const Track = styled.span`
  display: block;
  width: 100%;
  height: 6px;
  margin: 6px 0;
  overflow: hidden;
  border-radius: 25px;
  background-color: ${(p) => p.theme.progressBar.background};
`;

export const Fill = styled.span<{
  $progressPercent: number;
  $kind: ProgressBarKind;
}>`
  display: block;
  width: ${(p) => p.$progressPercent}%;
  height: 100%;
  border-radius: 25px;
  background-color: ${(p) => p.theme.progressBar.progress[p.$kind]};
  transition: width 100ms linear;

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.span`
  display: flex;
`;

export const Title = styled.span`
  font-size: 12px;
`;

export const Percentage = styled.span`
  margin-left: auto;
  font-size: 12px;
`;

export const Wrapper = styled.div`
  color: ${(p) => p.theme.progressBar.text};
`;
